import Lightbox from './components/Lightbox';

export default Lightbox;



// WEBPACK FOOTER //
// ./src/lib/index.js